import apiClient from './api'

export interface Dentist {
  id: number
  firstName: string
  lastName: string
  email: string
  practiceId: number | null
  practiceName: string | null
}

class DentistService {
  async GetDentists() {
    try {
      const response = await apiClient.get<Dentist[]>('/Admin/dentists')
      return { success: true, data: response.data }
    } catch (err) {
      return { success: false, data: [] as Dentist[] }
    }
  }

  // A null practice id unlinks the dentist; linking one who is already in a practice moves them
  async SetDentistPractice(dentistId: number, practiceId: number | null) {
    const response = await apiClient.put<Dentist>(`/Admin/dentist/${dentistId}/practice`, { practiceId })
    return response.data
  }
}

export default new DentistService()
